// Terms.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Terms.css";

function Terms() {
  return (
    <div className="terms-page">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/" className="brand-link" aria-label="메인으로 돌아가기">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="terms-title">
        <article className="generator-card terms-card" aria-labelledby="terms-title">
          <header className="terms-header">
            <h1 id="terms-title" className="card-title">TooLoves.net 이용약관</h1>
            <p className="card-subtitle terms-updated">
              마지막 업데이트:
              <time dateTime="2025-10-22"> 2025년 10월 22일(KST)</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              본 이용약관("약관")은 TooLoves.net 운영자("운영자")가 운영하는 웹사이트 TooLoves.net(이하 "사이트")의 
              이용과 관련하여 회원 및 방문자("이용자")가 지켜야 할 권리, 의무 및 책임사항을 규정합니다. 
              사이트를 이용함으로써 이용자는 본 약관에 동의한 것으로 간주됩니다.
            </p>
          </section>

          <section className="terms-section" id="purpose">
            <h2 className="section-title">1. 이용 목적</h2>
            <p>TooLoves.net은 QR 코드 생성기, 이미지 워터마크, AI 사진 EXIF 추출기 등 다양한 온라인 도구를 제공하여, 
              이용자가 빠르고 편리하게 디지털 작업을 수행할 수 있도록 지원합니다.</p>
          </section>

          <section className="terms-section" id="user-duties">
            <h2 className="section-title">2. 이용자 의무</h2>
            <ol>
              <li>이용자는 사이트를 이용함에 있어 관련 법령 및 본 약관을 준수해야 합니다.</li>
              <li>사이트의 기능을 악용하거나 불법·유해한 목적으로 사용해서는 안 됩니다.</li>
              <li>타인의 권리(저작권, 초상권, 개인정보 등)를 침해하는 행위를 금지합니다.</li>
              <li>
                다음과 같은 행위는 엄격히 금지됩니다: 
                리버스엔지니어링, 우회, 자동화된 데이터 수집, 서비스 방해, 
                보안 침해, 악성코드 유포, 불법 정보 게시, 타인 사칭, 
                과도한 요청으로 인한 과부하 유발 등.
              </li>
            </ol>
          </section>

          <section className="terms-section" id="service-changes">
            <h2 className="section-title">3. 서비스 제공 및 변경</h2>
            <ol>
              <li>운영자는 사이트의 안정적인 운영을 위해 필요한 경우 서비스 내용을 변경, 중단 또는 종료할 수 있습니다.</li>
              <li>이용자가 변경 후에도 서비스를 계속 이용하는 경우 변경 약관에 동의한 것으로 간주됩니다.</li>
              <li>운영자는 이용자가 본 약관 또는 관련 법령을 위반하거나 사이트 운영상 필요하다고 판단되는 경우, 
                별도의 동의나 고지 없이 이용자의 서비스 접근을 제한 또는 차단할 수 있습니다.</li>
            </ol>
          </section>

          <section className="terms-section" id="copyright">
            <h2 className="section-title">4. 저작권</h2>
            <ol>
              <li>사이트에 게시된 모든 콘텐츠(텍스트, 이미지, 코드 등)의 저작권은 운영자에게 귀속됩니다.</li>
              <li>이용자가 본 서비스를 통해 생성·업로드·전송하거나 타인에게 제공한 모든 정보 및 콘텐츠(이하 "이용자 생성 콘텐츠")의 저작권은 이용자 본인에게 있습니다.</li>
              <li>이용자는 개인적·비상업적 용도로만 콘텐츠를 사용할 수 있으며, 사이트 내부의 공유버튼을 이용한 방식 외의 배포는 금지됩니다.</li>
            </ol>
          </section>

          <section className="terms-section" id="liability">
            <h2 className="section-title">5. 책임 제한</h2>
            <ol>
              <li>운영자는 이용자가 사이트를 통해 생성한 데이터의 정확성·완전성·안전성·유해성을 보증하지 않습니다.</li>
              <li>이용자가 사이트 이용으로 발생한 손해에 대해 운영자는 법령상 허용되는 범위 내에서 책임을 지지 않습니다.</li>
              <li>이용자 생성 콘텐츠와 관련하여 발생하는 민·형사상 책임은 전적으로 해당 이용자가 부담하며, 
                  운영자는 이에 대해 어떠한 책임도 지지 않습니다.</li>
            </ol>
          </section>

          <section className="terms-section" id="privacy">
            <h2 className="section-title">6. 개인정보 보호</h2>
            <p>
              사이트 이용 시 수집되는 개인정보는 
              <Link to="/privacy" className="link" aria-label="개인정보 처리방침 보기"> 개인정보 처리방침</Link>
              에서 정한 바에 따라 안전하게 처리됩니다.
            </p>
          </section>

          <section className="terms-section" id="changes">
            <h2 className="section-title">7. 약관 변경</h2>
            <p>운영자는 필요에 따라 약관을 개정할 수 있으며, 변경된 약관은 사이트 공지 또는 알림을 통해 고지됩니다.</p>
            <p>이용자가 변경 후에도 사이트를 계속 이용하면 변경된 약관에 동의한 것으로 간주됩니다.</p>
          </section>

          <section className="terms-section" id="disputes">
            <h2 className="section-title">8. 분쟁 해결</h2>
            <p>본 약관 및 서비스와 관련된 분쟁은 대한민국 법률을 준거법으로 하며, 운영자 거주지를 관할하는 법원을 제1심 관할 법원으로 합니다.</p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">9. 문의</h2>
            <p>
              서비스 관련 문의는{" "}
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="helptooloves@gmail.com으로 이메일 보내기"
              >
                helptooloves@gmail.com
              </a>
              으로 문의 바랍니다.
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/" className="btn" aria-label="메인 페이지로 돌아가기">메인으로 돌아가기</Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">© 2025 TooLoves. All rights reserved.</footer>
    </div>
  );
}

export default Terms;
